import { useAuth } from '../auth/AuthContext.js';
import { apiFetch } from './client.js';

export function useApiFetch() {
  const { idToken, refreshTokens, signIn } = useAuth();
  return async (path: string, init?: RequestInit): Promise<Response> => {
    let response = await apiFetch(idToken, path, init);
    if (response.status === 401) {
      const newToken = await refreshTokens();
      if (newToken) {
        response = await apiFetch(newToken, path, init);
      } else {
        void signIn();
        throw new Error('Session expired. Please sign in again.');
      }
    }
    return response;
  };
}
